// extracted by mini-css-extract-plugin
export default {"title":"create_title__7d8Hg","container":"create_container__-+BVf","header":"create_header__KyJRZ"};